export const GET_SERVICE_REQUEST = "GET_SERVICE_REQUEST";
export const GET_SERVICE_SUCCESS = "GET_SERVICE_SUCCESS";
export const GET_SERVICE_FAILURE = "GET_SERVICE_FAILURE";

export const GET_PRODUCT_REQUEST = "GET_PRODUCT_REQUEST";
export const GET_PRODUCT_SUCCESS = "GET_PRODUCT_SUCCESS";
export const GET_PRODUCT_FAILURE = "GET_PRODUCT_FAILURE";

export const GET_FEATURED_PRODUCT_REQUEST = "GET_FEATURED_PRODUCT_REQUEST";
export const GET_FEATURED_PRODUCT_SUCCESS = "GET_FEATURED_PRODUCT_SUCCESS";
export const GET_FEATURED_PRODUCT_FAILURE = "GET_FEATURED_PRODUCT_FAILURE";

export const GET_PRODUCT_DETAIL_REQUEST = "GET_PRODUCT_DETAIL_REQUEST";
export const GET_PRODUCT_DETAIL_SUCCESS = "GET_PRODUCT_DETAIL_SUCCESS";
export const GET_PRODUCT_DETAIL_FAILURE = "GET_PRODUCT_DETAIL_FAILURE";

export const UPDATE_PRODUCT_REQUEST = "UPDATE_PRODUCT_REQUEST";
export const UPDATE_PRODUCT_SUCCESS = "UPDATE_PRODUCT_SUCCESS";
export const UPDATE_PRODUCT_FAILURE = "UPDATE_PRODUCT_FAILURE";

export const DELETE_PRODUCT_REQUEST = "DELETE_PRODUCT_REQUEST";
export const DELETE_PRODUCT_SUCCESS = "DELETE_PRODUCT_SUCCESS";
export const DELETE_PRODUCT_FAILURE = "DELETE_PRODUCT_FAILURE";

export const ADD_PRODUCT_REQUEST = "ADD_PRODUCT_REQUEST";
export const ADD_PRODUCT_SUCCESS = "ADD_PRODUCT_SUCCESS";
export const ADD_PRODUCT_FAILURE = "ADD_PRODUCT_FAILURE";

export const SERVICE_STATE_RESET = "SERVICE_STATE_RESET";

export const GET_TARGET_MEDIA_REQUEST = "GET_TARGET_MEDIA_REQUEST";
export const GET_TARGET_MEDIA_SUCCESS = "GET_TARGET_MEDIA_SUCCESS";
export const GET_TARGET_MEDIA_FAILURE = "GET_TARGET_MEDIA_FAILURE";

export const GET_TARGET_MEDIA_DETAIL_REQUEST =
  "GET_TARGET_MEDIA_DETAIL_REQUEST";
export const GET_TARGET_MEDIA_DETAIL_SUCCESS =
  "GET_TARGET_MEDIA_DETAIL_SUCCESS";
export const GET_TARGET_MEDIA_DETAIL_FAILURE =
  "GET_TARGET_MEDIA_DETAIL_FAILURE";
